/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

"use strict";

const Chunk = require("./Chunk");

/** @typedef {import("./ChunkGraph")} ChunkGraph */
/** @typedef {import("./util/Hash")} Hash */

class HotUpdateChunk extends Chunk {
	constructor() {
		super();
	}
}

module.exports = HotUpdateChunk;
